<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input
                v-model="groupBuyBatchManageInfo.conditions.groupBuyName"
                placeholder="请输入拼团名称"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="groupBuyBatchManageInfo.conditions.batchId"
                placeholder="请输入批次编号"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="groupBuyBatchManageInfo.conditions.settingId"
                placeholder="请输入团购设置ID"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="_queryProductMethod">
                <i class="el-icon-search"></i> 查询
              </el-button>
              <el-button @click="_resetProductMethod">
                <i class="el-icon-refresh"></i> 重置
              </el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>拼团批次</span>
          </div>
          <el-table
            :data="groupBuyBatchManageInfo.products"
            border
            style="width: 100%"
          >
            <el-table-column prop="batchId" label="批次ID" align="center" />
            <el-table-column prop="settingId" label="团购设置ID" align="center" />
            <el-table-column prop="groupBuyName" label="拼团名称" align="center" />
            <el-table-column prop="batchStartTime" label="开始时间" align="center" />
            <el-table-column prop="batchEndTime" label="结束时间" align="center" />
            <el-table-column prop="curBatch" label="当前批次" align="center">
              <template slot-scope="scope">
                {{ scope.row.curBatch == 'Y' ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="_toGroupBuy(scope.row)"
                >拼团列表</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="groupBuyBatchManageInfo.conditions.page"
            :page-size="groupBuyBatchManageInfo.conditions.row"
            layout="total, prev, pager, next, jumper"
            :total="groupBuyBatchManageInfo.total"
            style="margin-top: 20px; text-align: right;"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryGroupBuyBatch } from '@/api/goods/groupBuyBatchManageApi'

export default {
  name: 'GroupBuyBatchManage',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      groupBuyBatchManageInfo: {
        products: [],
        total: 0,
        records: 1,
        moreCondition: false,
        productId: '',
        conditions: {
          groupBuyName: '',
          keyword: '',
          barCode: '',
          batchId: '',
          settingId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._listProducts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleCurrentChange(val) {
      this._listProducts(val, this.DEFAULT_ROWS)
    },
    async _listProducts(_page, _rows) {
      this.groupBuyBatchManageInfo.conditions.page = _page
      this.groupBuyBatchManageInfo.conditions.row = _rows
      const param = {
        params: this.groupBuyBatchManageInfo.conditions
      }
      param.params.groupBuyName = param.params.groupBuyName.trim()
      param.params.batchId = param.params.batchId.trim()
      param.params.settingId = param.params.settingId.trim()

      try {
        const res = await queryGroupBuyBatch(param)
        this.groupBuyBatchManageInfo.total = res.total
        this.groupBuyBatchManageInfo.records = res.records
        this.groupBuyBatchManageInfo.products = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _queryProductMethod() {
      this._listProducts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetProductMethod() {
      this.groupBuyBatchManageInfo.conditions.groupBuyName = ""
      this.groupBuyBatchManageInfo.conditions.batchId = ""
      this.groupBuyBatchManageInfo.conditions.settingId = ""
      this._listProducts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _toGroupBuy(product) {
      this.$router.push(`/pages/goods/groupBuyManage?batchId=${product.batchId}`)
    }
  }
}
</script>

<style scoped>
.el-col {
  width: 100%;
}
</style>